<!-- src="/assets/pistoia/app.html" -->

<iframe
  id="oligo-editor"
  src="/assets/medchem/Default.htm"
  scrolling="no"
  style="width: 98%; height: 800px; overflow: hidden; padding: 1px;"
  #oligo_editor
  >____</iframe>

